var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3333 13.3332C10.7013 13.3332 11 13.0352 11 12.6665C11 12.4818 10.9253 12.3152 10.804 12.1945L6.60933 7.99984L10.804 3.80517C10.9253 3.6845 11 3.51784 11 3.33317C11 2.9645 10.7013 2.6665 10.3333 2.6665C10.1493 2.6665 9.98267 2.74117 9.86133 2.86184V2.86117L5.19467 7.52784C5.19133 7.53184 5.19 7.53784 5.186 7.54184C5.13 7.6005 5.08333 7.66784 5.05133 7.74384C5.018 7.8245 5 7.91184 5 7.99984C5 8.08784 5.018 8.17517 5.05133 8.25517C5.08533 8.3365 5.134 8.4105 5.19533 8.47184L9.86133 13.1378C9.982 13.2585 10.1487 13.3332 10.3333 13.3332Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalArrow);
export default __webpack_public_path__ + "static/media/cal_arrow.31f6d605fd16f5249684535c1daa0a14.svg";
export { ForwardRef as ReactComponent };